<template>
  <el-card>
    <template #header>
      <span>加入公司</span>
    </template>
    <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
      <el-tab-pane label="未审核公司邀请" name="first">
        <el-input placeholder="请输入公司名称" v-model="SearchCompanyUnknow" class="input-with-select" clearable
                  @clear="getInvitationList">
          <el-button slot="append" icon="el-icon-search" @click="SearchInvitationList(1)"></el-button>
        </el-input>
        <div style="margin: 10px 15px 10px 15px;">
          <el-table :data="CompanyUnKonw" style="width: 100%;text-align: center; height: 100%; " border
                    :header-cell-style="{ background: '#F2F2F2', color: '#333' }">
            <el-table-column prop="companyId" label="公司id" width="80" show-overflow-tooltip align="center"/>
            <el-table-column prop="companyName" label="公司名称" min-width="150" show-overflow-tooltip align="center"/>
            <el-table-column label="人员身份" min-width="110" show-overflow-tooltip align="center">
              <template slot-scope="scope">
                <div class="info-content" v-if="scope.row.role_type == 0">开发者</div>
                <div class="info-content" v-if="scope.row.role_type == 1">用户</div>
              </template>
            </el-table-column>
            <el-table-column label="同意邀请" width="200" show-overflow-tooltip align="center">
              <template slot-scope="scope">
                <el-button style="height:50px;width: 150px" type="primary" :plain="true"
                           @click="accept(scope.row)">
                  <i class="el-icon-check"></i>
                  <div style="font-size: 15px; font-weight: 400; font-style: normal;">同意</div>
                </el-button>
              </template>
            </el-table-column>
            <el-table-column label="拒绝邀请" width="200" align="center">
              <template slot-scope="scope">
                <el-button style="height:50px;width: 150px" type="warning" :plain="true"
                           @click="reject(scope.row)">
                  <i class="el-icon-close"></i>
                  <div style="font-size: 15px; font-weight: 400; font-style: normal;">拒绝</div>
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <el-dialog
            title="提示"
            :visible.sync="acceptDialogVisible"
            width="30%">
          <span>确认同意该公司邀请？</span>
          <span slot="footer" class="dialog-footer">
            <el-button @click="acceptDialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="applyCompanyUser">确 定</el-button>
          </span>
        </el-dialog>

        <el-dialog
            title="提示"
            :visible.sync="rejectDialogVisible"
            width="30%">
          <span>确认拒绝该公司邀请？</span>
          <span slot="footer" class="dialog-footer">
            <el-button @click="rejectDialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="applyCompanyUser">确 定</el-button>
          </span>
        </el-dialog>
      </el-tab-pane>
      <el-tab-pane label="已通过公司邀请" name="second">
        <el-input placeholder="请输入公司名称" v-model="SearchCompanyPass" class="input-with-select" clearable
                  @clear="getInvitationList">
          <el-button slot="append" icon="el-icon-search" @click="SearchInvitationList(2)"></el-button>
        </el-input>
        <div style="margin: 10px 15px 10px 15px;">
          <el-table :data="CompanyListPass" style="width: 100%;text-align: center; height: 100%; " border
                    :header-cell-style="{ background: '#F2F2F2', color: '#333' }">
            <el-table-column prop="companyId" label="公司id" width="80" show-overflow-tooltip align="center"/>
            <el-table-column prop="companyName" label="公司名称" min-width="180" show-overflow-tooltip align="center"/>
            <el-table-column label="人员身份" min-width="110" show-overflow-tooltip align="center">
              <template slot-scope="scope">
                <div class="info-content" v-if="scope.row.role_type == 0">开发者</div>
                <div class="info-content" v-if="scope.row.role_type == 1">用户</div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-tab-pane>
      <el-tab-pane label="已拒绝公司邀请" name="third">
        <el-input placeholder="请输入公司名称" v-model="SearchCompanyFail" class="input-with-select" clearable
                  @clear="getInvitationList">
          <el-button slot="append" icon="el-icon-search" @click="SearchInvitationList(3)"></el-button>
        </el-input>
        <div style="margin: 10px 15px 10px 15px;">
          <el-table :data="CompanyListFail" style="width: 100%;text-align: center; height: 100%; " border
                    :header-cell-style="{ background: '#F2F2F2', color: '#333' }">
            <el-table-column prop="companyId" label="公司id" width="80" show-overflow-tooltip align="center"/>
            <el-table-column prop="companyName" label="公司名称" min-width="180" show-overflow-tooltip align="center"/>
            <el-table-column label="人员身份" min-width="110" show-overflow-tooltip align="center">
              <template slot-scope="scope">
                <div class="info-content" v-if="scope.row.role_type == 0">开发者</div>
                <div class="info-content" v-if="scope.row.role_type == 1">用户</div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-tab-pane>
    </el-tabs>
  </el-card>
</template>

<script>
import API from "../../../../../config/api";

export default {
  data() {
    return {
      activeName: 'first',//tab选中的
      CompanyUnKonw: [],   //公司列表
      CompanyListPass: [],
      CompanyListFail: [],
      SearchCompanyUnknow: '',  //搜索内容
      SearchCompanyPass: '',
      SearchCompanyFail: '',
      companySendId: '',  //处理公司邀请的id
      isAccept: '',       //拒绝公司邀请还是同意公司邀请
      acceptDialogVisible: false, //同意公司邀请的对话框可视化
      rejectDialogVisible: false, //拒绝公司邀请的对话框可视化
    }
  },
  mounted() {
    //用户获取已经通过邀请的公司列表
    this.getInvitationList();
    this.userId = window.localStorage.getItem('userid');
    console.log('选择公司userId的值=', this.userId);
  },
  methods: {
    //页面切换
    handleClick(tab) {
      console.log(tab);
      this.activeName = tab.name;
      this.getInvitationList();
    },
    //用户获取邀请列表
    getInvitationList() {
      console.log(this.btnShow)
      console.log('开始获取公司邀请列表ing')
      let header = {
        "Content-Type": "application/x-www-form-urlencoded"
      }
      let data = {}
      console.log(data)
      this.$axiosRequest({
        url: API.getUserCompanyList,
        method: 'POST',
        data: data,
        header: header,
        success: res => {
          console.log("第一页")
          let list = res.data["companyList"];
          this.CompanyUnKonw = [];
          this.CompanyListPass = [];
          this.CompanyListFail = [];
          for (let i = 0; i < list.length; i++) {
            if (list[i].isAccept == 0)         //找出还没审核加入的公司
            {
              this.CompanyUnKonw.push(list[i]);
            }
          }
          for (let i = 0; i < list.length; i++) {
            if (list[i].isAccept == 1)         //找出已经成功的公司
            {
              this.CompanyListPass.push(list[i]);
            }
          }
          for (let i = 0; i < list.length; i++) {
            if (list[i].isAccept == 2)         //找出拒绝加入的公司
            {
              this.CompanyListFail.push(list[i]);
            }
          }
          console.log("eeeee", this.CompanyUnKonw);
          console.log("eeeee", this.CompanyListPass);
          console.log("eeeee", this.CompanyListFail);
        }

      })
    },
    //根据公司名称进行搜索
    SearchInvitationList(a) {
      let header = {
        "Content-Type": "application/x-www-form-urlencoded"
      }
      var companyName = '';
      if (a == 1) {
        companyName = this.SearchCompanyUnknow;
      }
      if (a == 2) {
        companyName = this.SearchCompanyPass;
      }
      if (a == 3) {
        companyName = this.SearchCompanyFail;
      }

      let data = {
        companyName: companyName,
      }
      console.log(data)
      this.$axiosRequest({
        url: API.getUserCompanyList,
        method: 'POST',
        data: data,
        header: header,
        success: res => {
          console.log("第一页")
          let list = res.data["companyList"];
          this.CompanyUnKonw = [];
          this.CompanyListPass = [];
          this.CompanyListFail = [];
          if (a == 1) {
            for (let i = 0; i < list.length; i++) {
              if (list[i].isAccept == 0)         //找出还没审核加入的公司
              {
                this.CompanyUnKonw.push(list[i]);
              }
            }
          } else if (a == 2) {
            for (let i = 0; i < list.length; i++) {
              if (list[i].isAccept == 1)         //找出已经成功的公司
              {
                this.CompanyListPass.push(list[i]);
              }
            }
          } else if (a == 3) {
            for (let i = 0; i < list.length; i++) {
              if (list[i].isAccept == 2)         //找出拒绝加入的公司
              {
                this.CompanyListFail.push(list[i]);
              }
            }
          }

        }

      })
    },
    //同意对话框
    accept(item) {
      this.acceptDialogVisible = true;
      this.companySendId = item.companyId;
      this.isAccept = 1;
    },
    //拒绝对话框
    reject(item) {
      this.rejectDialogVisible = true;
      this.companySendId = item.companyId;
      this.isAccept = 2;
    },
    //用户同意或者拒绝公司邀请
    applyCompanyUser() {
      let self = this;
      let header = {
        "Content-Type": "application/x-www-form-urlencoded"
      }
      let data = {
        isAccept: this.isAccept,
        companyId: this.companySendId
      }
      this.$axiosRequest({
        url: API.applyCompanyUser,
        method: 'POST',
        data: data,
        header: header,
        success: res => {
          console.log(res.data)
          if (res.data == 1) {
            self.$message({type: 'success', message: '成功'});
            this.rejectDialogVisible = false;
            this.acceptDialogVisible = false;
            this.getInvitationList()
          } else if (res.data == -2) {
            self.$message({type: 'warning', message: '参数错误，失败'});
            this.rejectDialogVisible = false;
            this.acceptDialogVisible = false;
          } else if (res.data == -1) {
            self.$message({type: 'warning', message: '程序错误'});
            this.rejectDialogVisible = false;
            this.acceptDialogVisible = false;
          }
        }
      })

    },

  }
}
</script>

<style scoped>

</style>